import { Component, ViewChild, ElementRef } from '@angular/core';
import pinyin from 'pinyin';
import { EcatService } from 'src/app/services/ecat.service';
import { Router } from '@angular/router';
import { encryptParam } from 'src/app/utils/encrypt';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
import { environment } from 'src/environments/environment';

// src/app/models/car.model.ts
// 定义数据接口
interface CarModel {
    id: string;
    name: string;
    selected: boolean;
}

interface CarSeries {
    id: string;
    name: string;
    models: CarModel[];
    manufacturer: any;
    modelClass: any;
}

interface Manufacturer {
    id: string;
    name: string;
    expanded: boolean; // 是否展开
    seriesList: CarSeries[];
}
@Component({
    selector: 'search-by-car',
    templateUrl: './search-by-car.component.html',
    styleUrls: ['./search-by-car.component.less']
})
export class SearchByCarComponent {
    @ViewChild('loadMoreAnchor') loadMoreAnchor!: ElementRef;
    @ViewChild('scrollContainer') scrollContainer!: ElementRef;
    selectedBrandName: string | null = null;
    selectedBrandId: number | null = null;
    selectedModel: any;
    allBrands: any[] = [];
    allFilteredSeries: any[] = [];
    allFilteredModels: any[] = [];
    allFilteredYears = [];
    allCarModels: any[] = [];
    selectedYear = '';
    loading = false;
    isSearchByBrandVisible = false;
    isSearchByTypeVisible = false;
    isSearchByYearVisible = false;
    indeterminate = false;
    mySelections: string[] = [];
    activeLetter: string = '';
    hotBrands = [
        { id: 1, brand: '大众', image: 'assets/official-website/das.png' },
        { id: 2, brand: '宝马', image: 'assets/official-website/bmw.png' },
        { id: 3, brand: '奔驰', image: 'assets/official-website/benz.png' },
        { id: 4, brand: '奥迪', image: 'assets/official-website/audi.png' },
        { id: 5, brand: '斯柯达', image: 'assets/official-website/sikeda.png' },
        { id: 6, brand: '本田', image: 'assets/official-website/honda.png' },
        { id: 7, brand: '丰田', image: 'assets/official-website/toyota.png' },
        { id: 8, brand: '日产', image: 'assets/official-website/nissan.png' },
        { id: 9, brand: '马自达', image: 'assets/official-website/mazda.png' },
        { id: 10, brand: '别克', image: 'assets/official-website/buick.png' },
        { id: 11, brand: '雪佛兰', image: 'assets/official-website/cheverlet.png' },
        { id: 12, brand: '凯迪拉克', image: 'assets/official-website/kaidilake.png' },
        { id: 13, brand: '福特', image: 'assets/official-website/ford.png' },
        { id: 14, brand: '沃尔沃', image: 'assets/official-website/volvo.png' },
        { id: 15, brand: '现代', image: 'assets/official-website/xiandai.png' },
        { id: 16, brand: '起亚', image: 'assets/official-website/kia.png' },
        { id: 17, brand: '标致', image: 'assets/official-website/biaozhi.png' },
        { id: 18, brand: '雪铁龙', image: 'assets/official-website/xuetielong.png' },
        { id: 19, brand: '荣威', image: 'assets/official-website/rongwei.png' },
        { id: 20, brand: '比亚迪', image: 'assets/official-website/byd.png' },
    ];
    brandLetters: string[] = [];
    brandsByLetter: { [key: string]: any[] } = {};
    pageIndex = 1;
    pageSize = 10;
    loadingMore = false;
    hasMore = true;
    selectedCarModels: any[] = [];
    unSelectedCarModels: Set<string> = new Set<string>();
    isSelectAllChecked = false;
    isAllSelected = false;
    isInitialLoading = false;
    // 当前选中的车系
    currentSeries: CarSeries | null = null;
    confirmModal?: NzModalRef;
    isDealerPortal: boolean = false;

    private observer!: IntersectionObserver;

    constructor(private ecatService: EcatService,
        private message: NzMessageService,
        private modal: NzModalService,
        private sharedData: SharedDataService,
        private router: Router,) {
        this.sharedData.currentData.subscribe(data => {
            this.isDealerPortal = data.isDealerPortal;
        });
    }

    ngAfterViewInit(): void {
        this.createObserver();
    }

    createObserver(): void {
        this.observer?.disconnect();

        this.observer = new IntersectionObserver(
            entries => {
                console.log('触发 observer', entries[0].isIntersecting);
                if (entries[0].isIntersecting) {
                    this.loadNextPage();
                }
            },
            {
                root: this.scrollContainer.nativeElement, // ✅ 关键
                threshold: 0.1
            }
        );

        this.observer.observe(this.loadMoreAnchor.nativeElement);
    }

    ngOnInit(): void {
        this.switchVisible('brand')
    }

    onSelectedIndexChanged(index: number) {
        if (index === 0) {
            this.switchVisible('brand');
            this.allFilteredSeries = [];
            this.currentSeries = null;
            this.resetCheckStatus();
        } else if (index === 1) {
            this.switchVisible('type');
            this.currentSeries = null;
            this.resetCheckStatus();
        } else {
            this.switchVisible('type');
            this.resetCheckStatus();
            this.selectSeries(this.currentSeries);
        }
    }

    resetCheckStatus() {
        this.allFilteredModels = [];
        this.selectedModel = null;

        this.selectedYear = '';

        this.allCarModels = [];
        this.isAllSelected = false;
        this.indeterminate = false;
        this.isSelectAllChecked = false;
        this.selectedCarModels = [];
    }

    switchVisible(displayName: string) {
        switch (displayName) {

            case 'brand': {
                this.isSearchByBrandVisible = true;
                this.isSearchByTypeVisible = false;
                this.isSearchByYearVisible = false;
                this.getBrand();
                break;
            }
            case 'type': {
                this.isSearchByBrandVisible = false;
                this.isSearchByTypeVisible = true;
                this.isSearchByYearVisible = false;
                break;
            }
            case 'year': {
                this.isSearchByBrandVisible = false;
                this.isSearchByTypeVisible = false;
                this.isSearchByYearVisible = true;
                break;
            }
            default: {
                this.isSearchByBrandVisible = true;
                this.isSearchByTypeVisible = false;
                this.isSearchByYearVisible = false;
            }
        }
    }

    onSelectionsChanged(item: any) {
        // const brand: any = this.allBrands.find((item: any) => item.brandName === brandName[0]);
        this.selectByInput(item);
    }

    /** 点击品牌 */
    selectByInput(item: any) {
        this.selectedBrandName = item.brandName;
        this.selectedBrandId = item.brandId;
        this.switchVisible('type');
        this.getSeriesList(item.brandId);
        setTimeout(() => {
            this.selectSeries(item);
        }, 1000);
    }

    selectHotBrand(car: any): void {
        const brand: any = this.allBrands.find((item: any) => item.brandName === car.brand);
        this.selectBrand(brand);
    }

    getBrand() {
        this.loading = true;
        this.ecatService.getBrand({
            languageType: 'zh-cn'
        }).subscribe(result => {
            const { resultCode, resultData } = result;
            this.allBrands = resultData.carBrand;
            this.groupBrandsByLetter(resultData.carBrand);
            this.loading = false;
        });
    }

    getSeriesList(item: any) {
        this.loading = true;
        this.ecatService.seriesList({ brandId: item, languageType: 'zh-cn' }).subscribe(result => {
            const { resultCode, resultData } = result;
            const arr = resultData.carSeriesList.map((item: any) => ({
                ...item,
                expanded: true
            }));
            this.allFilteredSeries = arr;
            this.loading = false;
        });
    }

    onSelectSeriesChange(item: any) {
        this.loading = true;
        if (item === null) {
            return;
        }
        const encodedManufacture = encodeURIComponent(item.manufacturer);
        const data = {
            brandId: item.brandId,
            modelId: '',
            modelClass: item.modelClass + ',' + encodedManufacture,
            displacement: '',
            modelYear: '',
            languageType: 'zh-cn',
            sop: '',
            eop: ''
        }
        this.ecatService.modelYearDisplacementList(data).subscribe(result => {
            const { resultCode, resultData } = result;
            this.allFilteredModels = resultData.carModelList;
            this.loading = false;
        });
    }


    getFirstLetter(name: string): string {
        const firstChar = name.charAt(0);

        // 1. 英文字母（A-Z / a-z）
        if (/^[A-Za-z]$/.test(firstChar)) {
            return firstChar.toUpperCase();
        }

        // 2. 数字 → 放入 "#" 分组
        if (/^\d$/.test(firstChar)) {
            return '#';
        }

        // 3. 中文名称 → 用拼音库获取首字母
        const py = pinyin(name, {
            style: pinyin.STYLE_FIRST_LETTER
        });
        return py[0][0].toUpperCase();
    }

    /** 使用拼音库分组品牌 */
    groupBrandsByLetter(carBrands: any) {
        this.brandsByLetter = {};

        carBrands.forEach((brand: any) => {
            const letter = this.getFirstLetter(brand.brandName);

            if (!this.brandsByLetter[letter]) {
                this.brandsByLetter[letter] = [];
            }
            this.brandsByLetter[letter].push(brand);
        });

        const sortedLetters = Object.keys(this.brandsByLetter)
            .sort()
            .filter(l => l !== '#')
            .concat('#');

        this.brandLetters = ['热', ...sortedLetters];

        this.activeLetter = '热';
    }

    /** 点击品牌 */
    selectBrand(brand: any) {
        this.selectedBrandName = brand.brandName;
        this.selectedBrandId = brand.brandId;
        this.mySelections.push(brand.brandName);
        this.switchVisible('type');
        this.getSeriesList(brand.brandId);
        this.scrollToTop();
    }

    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // 平滑滚动
        });
    }

    handleSelectYear(year: string) {
        if (this.selectedYear === year) {
            return;
        }
        this.pageSize = 10;
        this.allCarModels = [];
        this.hasMore = true;
        this.loadingMore = false;
        this.selectedYear = year;
        this.isInitialLoading = true;

        this.isAllSelected = false;
        this.indeterminate = false;
        this.isSelectAllChecked = false;
        this.selectedCarModels = [];

        setTimeout(() => {
            this.createObserver();
        });

        this.fetchCarModels();
    }

    fetchCarModels() {
        this.loading = true;
        const selectedSeries = this.currentSeries;
        const encodedManufacture = encodeURIComponent(selectedSeries?.manufacturer);
        const modelClass = selectedSeries?.modelClass;
        const params = {
            page: this.pageIndex,
            pageSize: this.pageSize,
            brandId: encryptParam(this.selectedBrandId ? this.selectedBrandId.toString() : ''),
            manufacturer: encryptParam(encodedManufacture),
            modelClass: encryptParam(modelClass),
            modelId: encryptParam(!this.isEmptyObject(this.selectedModel) ? this.selectedModel.modelId : ''),
            // displacement: encryptParam(this.selectedDisplacement.toString()),
            modelYear: encryptParam(this.selectedYear.toString()),
            languageType: encryptParam('zh-cn')
        }
        this.ecatService.carQuery(params).subscribe(result => {
            this.loading = false;
            const { resultCode, resultData } = result;
            this.allCarModels = resultData.carInfoList;

            if (this.isSelectAllChecked) {
                const newModels = resultData.carInfoList.slice(this.pageSize - 10);
                newModels.forEach((car: any) => this.selectedCarModels.push(car));
            }
            this.hasMore = resultData.carInfoList.length === this.pageSize;
            this.loadingMore = false;
            this.pageSize = this.pageSize + 10;
            this.isInitialLoading = false;
        });
    }

    loadNextPage(): void {
        if (this.loadingMore || !this.hasMore || this.isInitialLoading) {
            return;
        }
        this.loadingMore = true;
        this.fetchCarModels();
    }

    toggleDisplacement(carModel: any) {
        const index = this.selectedCarModels.findIndex(
            item => item.carId === carModel.carId
        );

        if (index > -1) {
            // 取消选中
            this.selectedCarModels.splice(index, 1);
            if (this.isSelectAllChecked) {
                this.unSelectedCarModels.add(carModel.carId);
            }
        } else {
            // 选中
            this.selectedCarModels.push(carModel);
            if (this.isSelectAllChecked) {
                this.unSelectedCarModels.delete(carModel.carId);
            }
        }

        if (this.isSelectAllChecked && this.unSelectedCarModels.size === 0) {
            this.isAllSelected = true;
        } else {
            this.isAllSelected = false;
        }
        if (this.isSelectAllChecked && this.unSelectedCarModels.size > 0) {
            this.indeterminate = true;
        } else if (!this.isSelectAllChecked && this.selectedCarModels.length > 0) {
            this.indeterminate = true;
        } else {
            this.indeterminate = false;
        }
    }

    isSelected(carModel: any): boolean {
        if (!carModel || !this.selectedCarModels) {
            return false;
        }
        return this.selectedCarModels.some(
            item => item.carId === carModel.carId
        );
    }

    scrollToLetter(letter: string) {
        this.activeLetter = letter;
        const container = document.querySelector('.brand-list') as HTMLElement;
        let targetElement: HTMLElement | null = null;

        if (letter === '热') {
            // 直接定位到你 HTML 里的 <div class="hot-brands">
            targetElement = document.querySelector('.hot-brands') as HTMLElement;
        } else {
            targetElement = document.getElementById('letter-' + letter);
        }

        if (targetElement && container) {
            // 计算目标相对于列表顶部的偏移量
            const topPos = targetElement.offsetTop;

            container.scrollTo({
                top: topPos,
                behavior: 'smooth'
            });
        }
    }

    // 切换厂商折叠状态
    toggleManufacturer(man: Manufacturer): void {
        man.expanded = !man.expanded;
    }

    // 选择左侧车系
    selectSeries(series: any): void {
        this.currentSeries = series;
        this.onSelectSeriesChange(series);
        this.mySelections.splice(1);
        this.mySelections.push(series.modelClass);
    }

    // 切换单个车型选中状态
    toggleModel(model: any): void {
        this.selectedModel = model;
        model.selected = !model.selected;
        this.mySelections.push(model.modelName);
        this.switchVisible('year');
        this.onSelectDisplacementChange(model);
        this.scrollToTop();
    }


    onSelectDisplacementChange(item: any) {
        this.loading = true;
        if (item === null) {
            return;
        }
        const selectedSeries = this.currentSeries;
        const encodedManufacture = encodeURIComponent(selectedSeries?.manufacturer);
        const modelClass = selectedSeries?.modelClass + ',' + encodedManufacture
        const params = {
            brandId: item.brandId, modelId: item.modelId, modelClass: modelClass,
            modelYear: '', languageType: 'zh-cn'
        }
        this.ecatService.modelyearList(params).subscribe(result => {
            const { resultCode, resultData } = result;
            this.allFilteredYears = resultData.modelYearList;
            this.loading = false;

            if (this.isSearchByYearVisible && this.allFilteredYears && this.allFilteredYears.length > 0) {
                this.handleSelectYear(this.allFilteredYears[0]);
            }
        });
    }

    // 点击全选/取消全选
    toggleSelectAll(checked: any): void {
        // this.isAllSelected = checked;
        this.indeterminate = false;
        this.isSelectAllChecked = checked;
        if (checked) {
            this.allCarModels.forEach(car => this.selectedCarModels.push(car));
        } else {
            this.selectedCarModels = [];
        }
        this.unSelectedCarModels = new Set<string>();
    }

    // 取消选择（清除当前页面所有选中）
    clearSelection(): void {
        this.selectedCarModels = [];
        this.unSelectedCarModels = new Set<string>();

        this.isAllSelected = false;
        this.indeterminate = false;
        this.isSelectAllChecked = false;
    }

    isEmptyObject(obj: any) {
        if (obj === null) {
            return true;
        }
        return Object.keys(obj).length === 0;
    }

    showConfirm(queryParams: any, selectedCarInfos: any): void {
        this.confirmModal = this.modal.confirm({
            nzTitle: '提示',
            nzContent: '当前选中条数超过100条请求超时，是否继续？',
            nzOnOk: () => {
                this.router.navigate(['gb/cn/parts/ecat-part-list'], {
                    state: { queryParams: queryParams, selectedCarInfos: selectedCarInfos, searchBySelectedCars: true }
                });
            }
        })
    }

    // 下一步
    nextStep(): void {
        if (!this.isSelectAllChecked && this.selectedCarModels.length === 0) {
            this.message.create('warning', '请至少选择一款车型');
        } else {
            let carIds = '';
            this.selectedCarModels.forEach((item: any) => {
                carIds = carIds + "," + item.carId;
            });
            const selectedCarInfos = this.selectedCarModels.map((item: any) => {
                return { "carFullInfo": item.carFullInfo, "engineOilOeGuideline": item.engineOilOeGuideline };
            });
            const selectedSeries = this.currentSeries;
            const encodedManufacture = selectedSeries?.manufacturer;
            const modelClass = selectedSeries?.modelClass;
            const params = {
                page: this.pageIndex,
                pageSize: this.pageSize,
                brandId: this.selectedBrandId ? this.selectedBrandId.toString() : '',
                manufacturer: encodedManufacture,
                modelClass: modelClass,
                // modelId: !this.isEmptyObject(this.selectedModel) ? this.selectedModel.modelId : '',
                // displacement: encryptParam(this.selectedDisplacement.toString()),
                modelYear: this.selectedYear.toString(),
                languageType: 'zh-cn',
                modelName: this.selectedModel.modelName,
                carIds: carIds,
                levelIds: "",
                isSelectAll: this.isSelectAllChecked ? '1' : '0',
            }

            if (this.isSelectAllChecked) {
                const unSelectedIds = Array.from(this.unSelectedCarModels);
                if (this.selectedCarModels.length > 100) {
                    params.carIds = unSelectedIds.toString();
                    this.showConfirm(params, selectedCarInfos);
                } else {
                    params.carIds = unSelectedIds.toString();
                    this.router.navigate(['gb/cn/parts/ecat-part-list'], {
                        state: { queryParams: params, selectedCarInfos: selectedCarInfos, searchBySelectedCars: true }
                    });
                }
            } else {
                this.router.navigate(['gb/cn/parts/ecat-part-list'], {
                    state: { queryParams: params, selectedCarInfos: selectedCarInfos, searchBySelectedCars: true }
                });
            }
            if (environment.production) {
                const userData = JSON.parse(localStorage.getItem('userData') || '{}');
                const customer = JSON.parse(localStorage.getItem('customer') || '{}');
                (window as any).dataLayer.push({
                    event: 'dp_eact_search_click',
                    from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
                    event_type: 'vehicle',
                    event_name: '',
                    portal_name: 'Mobile ' + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
                    event_content: selectedSeries?.manufacturer + " " + modelClass + " " + this.selectedYear.toString(),
                });
            }
        }
        this.scrollToTop();
    }
}
